import React, { useEffect, useState } from "react";
import { Button, Alert } from "reactstrap";

import ChallengeForm from "./ChallengeForm";
import "./monthlyChallengesDrawer.scss";

const ChallengeDrawer = ({
  isOpen,
  onClose,
  challenge,
  mode,
  title,
  onSubmit,
  onEdit,
  error,
}) => {
  const ANIMATION_MS = 250;
  const [shouldRender, setShouldRender] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleOverlayClick = (e) => {
    if (e.target.getAttribute("data-overlay") === "true") {
      setIsVisible(false);
      setTimeout(() => {
        onClose();
      }, ANIMATION_MS);
    }
  };

  const handleRequestClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, ANIMATION_MS);
  };

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      requestAnimationFrame(() => {
        setIsVisible(true);
      });
      return;
    }

    if (shouldRender) {
      setIsVisible(false);
      const timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, ANIMATION_MS);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isOpen, shouldRender]);

  if (!shouldRender) return null;

  return (
    <div
      className={[
        "monthly-challenges-drawer-overlay",
        isVisible ? "is-visible" : "",
      ].join(" ")}
      data-overlay="true"
      onClick={handleOverlayClick}
    >
      <div
        className={[
          "monthly-challenges-drawer",
          isVisible ? "is-visible" : "",
        ].join(" ")}
      >
        <div className="monthly-challenges-drawer-header">
          <div className="monthly-challenges-drawer-title">{title}</div>
          <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
            {mode === "view" && onEdit && (
              <Button
                color="primary"
                size="sm"
                onClick={onEdit}
              >
                Editar
              </Button>
            )}
            <Button
              color="link"
              className="monthly-challenges-drawer-close"
              onClick={handleRequestClose}
            >
              Cerrar
            </Button>
          </div>
        </div>

        <div className="monthly-challenges-drawer-content">
          {error && (
            <Alert color="danger" style={{ marginBottom: "1rem" }}>
              {error}
            </Alert>
          )}
          <ChallengeForm
            initialValues={challenge}
            mode={mode}
            onSubmit={onSubmit}
          />
        </div>
      </div>
    </div>
  );
};

ChallengeDrawer.defaultProps = {
  mode: "view",
  title: "Detalle del reto",
  onSubmit: undefined,
};

export default ChallengeDrawer;
